<template>
  <div>
    <b-row>
      <b-col md="12">
        <b-card no-body>
          <b-tabs card @input="onTabSelected">
            <div class="mx-3">
              <h5 class="my-2">
                <b>{{ $t("common.name") }}:</b>
                <p class="mx-2 d-inline d-inline">
                  {{ patientInfo.patient.name }}
                </p>
              </h5>
              <h5 class="my-2">
                <b>{{ $t("reception.gender") }}:</b>
                <p class="mx-2 d-inline d-inline">
                  {{ patientInfo.patient.gender }}
                </p>
              </h5>
              <h5 class="my-2">
                <b>{{ $t("reception.birth-date") }}:</b>
                <p class="mx-2 d-inline d-inline">
                  {{ patientInfo.patient.birth_date }}
                </p>
              </h5>
              <h5 class="my-2">
                <b>{{ $t("reception.occupation") }}:</b>
                <p class="mx-2 d-inline d-inline">
                  {{ patientInfo.patient.occupation }}
                </p>
              </h5>
              <h5 class="my-2">
                <b>{{ $t("reception.phone") }}:</b>
                <p
                  class="mx-2 d-inline"
                  :style="{
                    direction: $store.state.appConfig.isRTL ? 'rtl' : 'ltr',
                  }"
                >
                  {{ patientInfo.patient.phone }}
                </p>
              </h5>
            </div>
            <b-tab :title="$t('hospital.outclinic-invoices')" active>
              <b-card-text
                ><OutClinicInvoices
                  :patient-data="patientInfo"
                  :invoices="invoices"
                  @onChangeStatus="getInvoicesAfterChange()"
              /></b-card-text>
            </b-tab>
            <b-tab :title="$t('hospital.invoice-insurance-surgery')">
              <b-card-text>
                <div class="d-flex justify-content-end">
                  <b-button
                    v-if="$route.query.patientCardId && this.patientHasSurgery"
                    @click="
                      $router.push({
                        name: 'invoice-insurance-surgery',
                        params: {
                          id: $route.query.patientCardId,
                          name: patientInfo.name,
                        },
                      })
                    "
                  >
                    {{ $t("hospital.invoice-insurance-surgery") }}
                  </b-button>
                </div>
                <SurgeryInsuranceInvoices
                  :invoices="invoices"
                  @onChangeStatus="getInvoicesAfterChange()"
              /></b-card-text>
            </b-tab>
            <b-tab
              v-if="this.patientHasSurgery"
              :title="$t('hospital.patient-surgery-invoices')"
            >
              <b-card-text
                ><SurgeryInvoices
                  :get-data="getPatientSurgeriesInvoices"
                  :patient-data="patientInfo"
                  :patient-surgery-id="
                    this.patientHasSurgery && patientInfo.surgeries[0].id
                  "
                  :invoices="invoices"
                  @onChangeStatus="getPatientSurgeriesInvoices()"
              /></b-card-text>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BLink,
  BDropdown,
  BSpinner,
  BDropdownItem,
  BTooltip,
  BFormGroup,
  BFormSelect,
  BModal,
  BCardText,
  BFormCheckboxGroup,
  BFormCheckbox,
  BCardBody,
  BPagination,
  BTable,
  BTab,
  BTabs,
} from "bootstrap-vue";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import ActionsButtons from "@/components/common/ActionsButtons.vue";
import DeleteModal from "@/components/modals/DeleteModal.vue";

const PatientCard = () => import("@/views/Reception/PatientCard.vue");
const AutoComplete = () => import("@/components/common/AutoComplete.vue");
const OutClinicInvoices = () =>
  import("@/components/invoices/OutClinicInvoices.vue");
const SurgeryInsuranceInvoices = () =>
  import("@/components/invoices/SurgeryInsuranceInvoices.vue");
const SurgeryInvoices = () =>
  import("@/components/invoices/SurgeryInvoices.vue");
const OutClinicInvoice = () =>
  import("@/components/printables/OutClinicInvoice.vue");
export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BLink,
    BDropdown,
    BDropdownItem,
    BTooltip,
    BTab,
    BTabs,
    vSelect,
    ToastificationContent,
    VuePhoneNumberInput,
    DeleteModal,
    ActionsButtons,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BModal,
    BCardText,
    BFormCheckbox,
    BFormCheckboxGroup,
    BCardBody,
    BPagination,
    BTable,
    PatientCard,
    OutClinicInvoices,
    SurgeryInsuranceInvoices,
    SurgeryInvoices,
  },
  data() {
    return {
      patientCardsData: [],
      take: 20,
      invoices: {
        invoice_out_clinic: [],
        invoice_insurance_surgery: [],
        invoice_patinet_surgery: [],
      },
      currentPatienTCardId: "",
      patientInfo: { patient: {}, surgeries: [] },
      patientHasSurgery: false,
      itemClickedList: [],
      tableColumns: [
        {
          key: "amount",
          label: this.$t("employee.amount"),
          sortable: true,
        },

        {
          key: "created_at",
          sortable: true,
          label: this.$t("common.created-at"),
        },
        { key: "Actions", label: this.$t("common.actions") },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
      dataCount: 0,
    };
  },
  mounted() {
    this.getPatientCards();
  },
  methods: {
    getInvoicesAfterChange() {
      setTimeout(() => {
        window.location.reload();
      }, 200);
    },
    async getPatientCards() {
      this.loading = true;
      await this.getPatient(
        `/patientCard?include=patient,surgeries&take=20&filter[patient_id]=${this.$route.params.patientId}&sort=-id`
      );
      this.loading = false;
      for (const item in this.all_data) {
        if (this.all_data[item] == null) this.all_data[item] = "";
      }
      this.patientCardsData = Array.isArray(this.all_data.data)
        ? this.all_data.data
        : [];
      const first = this.patientCardsData[0] || {};
      // Normalize nested structures to avoid undefined access during render
      this.patientInfo = {
        ...first,
        patient: first.patient || {},
        surgeries: Array.isArray(first.surgeries) ? first.surgeries : [],
      };
      this.patientHasSurgery = (this.patientInfo.surgeries || []).length > 0;
    },

    onTabSelected(selectedTabIndex) {
      switch (selectedTabIndex) {
        case 0:
          this.getInvoices("invoice_out_clinic");
          break;
        case 1:
          this.getInvoices("invoice_insurance_surgery");
          break;
        case 2:
          this.getPatientSurgeriesInvoices();
          break;
      }
    },
    async getInvoices(type) {
      const url = `/invoices?filter[patient_card_id]=${this.$route.query.patientCardId}&filter[type]=${type}&page=${this.page}&take=${this.take}&sort=-id&include=service,surgery,patientCard,doctor`;
      console.log("get invoice");
      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.invoices = this.all_data;
      this.loading = false;
    },
    async getPatientSurgeriesInvoices() {
      if (this.patientHasSurgery) {
        const url = `/invoicePatientSergury?filter[patient_card_surgery_id]=${this.patientInfo.surgeries[0].id}&page=${this.page}&take=${this.take}&sort=-id`;

        await this.getList(url);
        this.dataCount = this.all_data.total;
        this.invoices = this.all_data;
        this.loading = false;
      } else {
      }
    },
    itemClicked(id) {
      this.currentPatienTCardId = id;
    },
  },
};
</script>
<style scoped>
.font-modify {
  letter-spacing: normal !important;
}

.pdf-content {
  margin: 2rem;
}

.modify_result_display {
  width: 25rem;
  margin: auto;
  color: rgb(255, 255, 255);
}

.modify_result_display_div {
  border-radius: 8px;
  margin: -22px;
  padding: 10px;
  margin-top: 10px;
  background: rgb(25, 0, 255);
}

.Risk_bg {
  margin: 1.5rem 0.5rem;
  border-radius: 8px;
  border-top: 3px solid rgb(25, 0, 255);
  border-left: 3px solid rgb(25, 0, 255);
  border-right: 3px solid rgb(25, 0, 255);
}

.timeline {
  max-width: 300px;
  color: #fdfdfd;
  padding: 30px 10px;
}

.timeline ul {
  list-style-type: none;
  border-left: 2px solid #094a68;
  padding: 10px 5px;
}

.timeline ul li {
  padding: 20px 10px;
  position: relative;
  cursor: pointer;
  transition: 0.5s;
  margin-top: 5px;
  max-width: 80%;
  word-wrap: break-word;
}

.timeline ul li span {
  color: #094a68;
  word-wrap: break-word;
}

.timeline ul li:before {
  position: absolute;
  content: "";
  width: 10px;
  height: 10px;
  background-color: #34ace0;
  border-radius: 50%;
  left: -11px;
  top: 28px;
  transition: 0.5s;
}

.timeline ul li:hover:before {
  background-color: rgb(255, 208, 0);
  box-shadow: 0px 0px 10px 2px rgb(255, 208, 0);
}

.timeline ul .clicked:before {
  background-color: #0f0;
  box-shadow: 0px 0px 10px 2px #0f0;
}

.timeline ul .unclicked:before {
  background-color: #34ace0;
  box-shadow: none;
}

@media (max-width: 300px) {
  .timeline {
    width: 100%;
    padding: 30px 5px 30px 10px;
  }

  .timeline ul li .content h3 {
    color: #34ace0;
    font-size: 15px;
  }
}

.section-visit {
  background: #ebebeb;
  margin-bottom: 1rem;
  padding: 1rem;
}

.section-consultant {
  margin: 1.5rem 0.5rem;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0px 6px 24px #e4e4e4;
}

.modify-consulting-paper {
  padding: 1rem;
  max-height: 100%;
  max-width: 100%;
}

.visit-row {
  margin-top: 2rem;
}

.section-visit-sec {
  margin: 1.75rem 0.5rem;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0px 6px 24px #e4e4e4;
}

.section-visit-summery {
  margin: 0.5rem;
  padding: 1rem;
  color: black;
  border-radius: 8px;
  box-shadow: 0px 6px 24px #e4e4e4;
}

.summery {
  background-color: rgba(237, 238, 245, 0.431);
  padding: 1.5rem;
  margin: 1rem;
  border-radius: 5px;
}

.total_score {
  background-color: rgb(237, 238, 245);
  padding: 0.5rem 1rem;
  border-radius: 15px;
  box-shadow: 0px 6px 10px #ebebeb;
}

table,
td,
th {
  border: 1px solid;
}

.sign-table,
.sign-table > tr > td {
  border: none !important;
}

table {
  width: 100%;
  background: white;
  border-collapse: collapse;
}

table > tr > td {
  width: 6rem;
  text-align: center;
}

.patient-table > tr > td {
  padding-left: 0.5rem;
  border: 1px solid;
  text-align: left;
}
</style>
